import { AttemptStatus } from "@/shared/constants/enum";
import { ExamType } from "@/shared/constants/type-vlue";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type State = {
  selectedExamType: ExamType;
  selectedAttemptStatus: AttemptStatus;
  classId: number | undefined;
  isVisitedPT: boolean;
};

type Action = {
  setSelectedExamType: (examType: ExamType) => void;
  setSelectedAttemptStatus: (attemptStatus: AttemptStatus) => void;
  setClassId: (classId: number | undefined) => void;
  clearPracticeTextIdStore: () => void;
  setIsVisitedPT: (isVisitedPT: boolean) => void;
};

const initial: State = {
  selectedExamType: ExamType.ME,
  selectedAttemptStatus: AttemptStatus.NotStarted,
  classId: undefined,
  isVisitedPT: false,
};

export const useExamTabsStore = create<State & Action>()(
  persist(
    (set) => ({
      ...initial,
      setSelectedExamType: (examType: ExamType) =>
        set({ selectedExamType: examType }),
      setClassId: (classId: number | undefined) => set({ classId }),
      setSelectedAttemptStatus: (attemptStatus: AttemptStatus) =>
        set({ selectedAttemptStatus: attemptStatus }),
      setIsVisitedPT: (isVisitedPT: boolean) => set({ isVisitedPT }),
      clearPracticeTextIdStore: () => set({ ...initial }),
    }),
    {
      name: "exam-tabs-store",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
